import {
  BrandJsonLd,
  DefaultSeo,
  LocalBusinessJsonLd,
  LogoJsonLd,
  SocialProfileJsonLd,
  WebPageJsonLd,
} from "next-seo";

import baseUrl from "../lib/baseUrl";
import { CommonProps } from "../lib/getCommonProps";
import Footer from "./Footer";
import Header from "./Header";
import PreviewAlert from "./PreviewAlert";

type Props = {
  children: React.ReactNode;
  preview?: boolean;
} & CommonProps;

const Layout = ({ children, preview, ...commonProps }: Props) => {
  return (
    <div className="flex flex-col justify-between h-screen subpixel-antialiased">
      <DefaultSeo
        title="Welfare Abroad"
        titleTemplate="%s | Welfare Abroad"
        openGraph={{
          type: "website",
          locale: "en_US",
          url: baseUrl,
          images: [{ url: baseUrl + "/logo.png", alt: "Welfare Abroad Logo" }],
          site_name: "Welfare Abroad",
        }}
        // twitter={{
        //   handle: "@handle",
        //   site: "@site",
        //   cardType: "summary_large_image",
        // }}
      />
      <LogoJsonLd logo={baseUrl + "/logo.png"} url={baseUrl} />
      <BrandJsonLd id={baseUrl} logo={baseUrl + "/logo.png"} />
      <WebPageJsonLd id={baseUrl} lastReviewed={new Date().toISOString()} />
      <SocialProfileJsonLd
        type="Organization"
        name="Welfare Abroad"
        url={baseUrl}
        sameAs={[
          "https://www.facebook.com/hairtransplantabroad/",
          "https://www.instagram.com/welfare.abroad/",
          "https://uk.linkedin.com/in/welfare-abroad-520b441b3",
          "https://www.youtube.com/channel/UCXx9z0C-q0lrLP44-MBdCrg",
        ]}
      />
      <LocalBusinessJsonLd
        type="MedicalBusiness"
        id={baseUrl}
        name="Welfare Abroad"
        description="Looking for affordable treatments in Istanbul, Turkey? Welfare Abroad offers fully customizable medical travel packages for FUE Hair Transplant, Dentistry."
        url={baseUrl}
        telephone="+447503753001"
        address={{
          streetAddress:
            "Küçükbakkalköy, Saç Ekimi Bölümü, Işıklar Cd. No: 28 D:Kat: 7",
          addressLocality: "Ataşehir",
          addressRegion: "İstanbul",
          postalCode: "34750",
          addressCountry: "TR",
        }}
        geo={{
          latitude: "40.985079",
          longitude: "29.1098",
        }}
        images={[`${baseUrl}/logo.png`]}
        openingHours={[
          {
            opens: "09:00",
            closes: "20:00",
            dayOfWeek: [
              "Monday",
              "Tuesday",
              "Wednesday",
              "Thursday",
              "Friday",
              "Saturday",
            ],
          },
        ]}
        // rating={{
        //   ratingValue: "4.5",
        //   ratingCount: "2",
        // }}
        // review={[
        //   {
        //     author: "John Doe",
        //     datePublished: "2006-05-04",
        //     name: "A masterpiece of literature",
        //     reviewBody:
        //       "I really enjoyed this book. It captures the essential challenge people face as they try make sense of their lives and grow to adulthood.",
        //     reviewRating: {
        //       bestRating: "5",
        //       worstRating: "1",
        //       reviewAspect: "Ambiance",
        //       ratingValue: "4",
        //     },
        //   },
        //   {
        //     author: "Bob Smith",
        //     datePublished: "2006-06-15",
        //     name: "A good read.",
        //     reviewBody:
        //       "Catcher in the Rye is a fun book. It's a good book to read.",
        //     reviewRating: {
        //       ratingValue: "4",
        //     },
        //   },
        // ]}
        // action={{
        //   actionName: "potentialAction",
        //   actionType: "ReviewAction",
        //   target: "https://www.example.com/review/this/business",
        // }}
      />
      <Header {...commonProps} />
      {preview && <PreviewAlert />}
      <main className="mb-auto">{children}</main>
      <Footer {...commonProps} />
    </div>
  );
};

export default Layout;
